import { render, staticRenderFns } from "./UploadZodiac.vue?vue&type=template&id=115aae5c&scoped=true&"
import script from "./UploadZodiac.vue?vue&type=script&lang=js&"
export * from "./UploadZodiac.vue?vue&type=script&lang=js&"
import style0 from "./UploadZodiac.vue?vue&type=style&index=0&id=115aae5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115aae5c",
  null
  
)

export default component.exports